import { getDefaultDialogConfig } from '@/utils/constants'
import { createStore } from 'vuex'
import {
  CLOSE_DIALOG,
  OPEN_DIALOG,
  RESET_PAGE_NOT_FOUND,
  SET_PAGE_NOT_FOUND,
  SET_LOADING,
  CLEAR_LOADING,
} from './actions'
import BarcodeModule from './barcode'
import BizBrowserModule from './bizBrowser/bizBrowser'
import LocationModule from './location'
import NotificationModule from './notification'
import ProfileModule from './profile'
import ProjectModule from './project'
interface TAppState {
  dialogVisible: boolean
  dialogConfig: {
    title: string
    message: string
    confirmation: boolean
    needtranslation?: boolean
  }
  isNotFound: boolean
  notFoundItem: string
  loading: boolean
}

export default createStore({
  strict: true,
  state: {
    dialogVisible: false,
    dialogConfig: {
      title: '',
      message: '',
      confirmation: true,
    },
    isNotFound: false,
    notFoundItem: '',
    loading: false,
  },
  getters: {
    isLoading: (state: TAppState) => {
      return state.loading
    },
  },
  mutations: {
    [OPEN_DIALOG]: (
      state: TAppState,
      payload: {
        title: string
        message: string
        confirmation: boolean
      }
    ) => {
      state.dialogVisible = true
      state.dialogConfig = payload
    },
    [CLOSE_DIALOG]: (state: TAppState) => {
      state.dialogVisible = false
      state.dialogConfig = getDefaultDialogConfig()
    },
    [SET_PAGE_NOT_FOUND]: (state: TAppState, payload: { item: string }) => {
      state.isNotFound = true
      state.notFoundItem = payload.item
    },
    [RESET_PAGE_NOT_FOUND]: (state: TAppState) => {
      state.isNotFound = false
      state.notFoundItem = ''
    },
    [SET_LOADING]: (state: TAppState) => {
      state.loading = true
    },
    [CLEAR_LOADING]: (state: TAppState) => {
      state.loading = false
    },
  },
  actions: {
    [OPEN_DIALOG]: (
      {
        commit,
      }: {
        commit: Function
      },
      payload: {
        title?: string
        message: string
        confirmation?: boolean
        needtranslation?: boolean
      }
    ) => {
      commit(OPEN_DIALOG, { ...getDefaultDialogConfig(), ...payload })
    },
    [CLOSE_DIALOG]: ({ commit }: { commit: Function }) => {
      commit(CLOSE_DIALOG)
    },
    [SET_PAGE_NOT_FOUND]: (
      {
        commit,
      }: {
        commit: Function
      },
      payload: {
        item: string
      }
    ) => {
      commit(SET_PAGE_NOT_FOUND, payload)
    },
    [RESET_PAGE_NOT_FOUND]: ({ commit }: { commit: Function }) => {
      commit(RESET_PAGE_NOT_FOUND)
    },
    [SET_LOADING]: ({ commit }: { commit: Function }) => {
      commit(SET_LOADING)
    },
    [CLEAR_LOADING]: ({ commit }: { commit: Function }) => {
      commit(CLEAR_LOADING)
    },
  },
  modules: {
    profile: ProfileModule,
    project: ProjectModule,
    barcode: BarcodeModule,
    notification: NotificationModule,
    location: LocationModule,
    bizBrowser: BizBrowserModule,
  },
})
